import { render, staticRenderFns } from "./PanelCompetitionNavMobile.vue?vue&type=template&id=1f215bca&scoped=true&"
import script from "./PanelCompetitionNavMobile.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionNavMobile.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionNavMobile.vue?vue&type=style&index=0&id=1f215bca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f215bca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f215bca')) {
      api.createRecord('1f215bca', component.options)
    } else {
      api.reload('1f215bca', component.options)
    }
    module.hot.accept("./PanelCompetitionNavMobile.vue?vue&type=template&id=1f215bca&scoped=true&", function () {
      api.rerender('1f215bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionNavMobile.vue"
export default component.exports